/**
 * 九州うまかハーブ鶏 LP（sections/umaka-herbdori.liquid）
 * 現状は静的コンテンツのみ。将来のアニメーション等のフック用。
 */
export function initUmakaHerbdori(): void {
  const root = document.querySelector("[data-umaka-herbdori]");
  if (!root) return;
}
